import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { BankAccountDetailResponseDto } from "../../dtos/bank-account-dto";
import { BankAccountService } from "../../services/bank-account-service";

export const useGetBankAccountRevealDetailQuery = ({
  bankInfoId,
  options
}: {
  bankInfoId: string;
  options?: Omit<
    UseQueryOptions<BankAccountDetailResponseDto>,
    "queryKey" | "queryFn"
  >;
}) => {
  return useQuery({
    queryKey: ["bankAccountRevealDetail", bankInfoId],
    queryFn: async () => await BankAccountService.revealDetail({ bankInfoId }),
    staleTime: Infinity,
    gcTime: Infinity,
    ...options
  });
};
